import React from 'react';
import { BetCountsLoader } from '@/mytickets/components/bet-counts/BetCounts';
import MultipleComponentsLoader from '@/common/components/loaders/MultipleComponentsLoader';
import BetLoader from '@/mytickets/detail/views/BetLoader';

export function TicketDetailLoader({ isSingleTicket = true }) {
    return (
        <div className="tickets-detail">
            {!isSingleTicket ? <InnerSliderLoader itemsCount={5} /> : null}
            <TicketHeaderLoader />
            <MultipleComponentsLoader componentLoader={BetLoader} itemsCount={2} />
            <TicketFooterLoader />
        </div>
    );
}

function InnerSliderLoader({ itemsCount = 0 }) {
    return (
        <div className="ticket-detail-slider">
            <MultipleComponentsLoader componentLoader={SliderItemLoader} itemsCount={itemsCount} />
        </div>
    );
}

function SliderItemLoader() {
    return (
        <div className="ticket-detail-slider-item-new loader">
            <div className="ticket-detail-slider-item-content">
                <div className="ticket-detail-ticket-state">
                    <div className="ticket-state" />
                </div>
                <div className="item-values">
                    <div className="stake wave-animation" />
                    <div className="win wave-animation" />
                </div>
            </div>
        </div>
    );
}

function TicketHeaderLoader() {
    return (
        <div className="ticket-header loader">
            <div className="ticket-numbers-section">
                <div className="row">
                    <div className="big wave-animation" />
                    <BetCountsLoader />
                </div>
                <div className="row second wave-animation" />
            </div>
        </div>
    );
}

function TicketFooterLoader() {
    return (
        <>
            <div className="tickets-detail-gap-20" />
            <div className="ticket-detail-footer-loader">
                <div className="mini-preloader">
                    <div className="mini-preloader-content" />
                </div>
            </div>
        </>
    );
}

export default TicketDetailLoader;
